

import FileUploader from '@/components/file_uploader/FileUploader.vue'
import NavigationLinks from '@/components/navigation_link/NavigationLinks.vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import ToastMixin from '@/mixins/ToastMixin'
import FormContainer from '../../commons/forms/FormContainer.vue'
import TextFieldEditor from '../../commons/fields/TextFieldEditor.vue'
import { API_URLS } from "@/utils/helpers"
import { IPSResultReport } from "@/types/processingSteps"
import RadioButtons from "@/components/processing_steps/commons/fields/RadioButtons.vue"
import DocumentField from '../../commons/fields/DocumentField.vue'
import { IPhoto } from '@/types/photos'
import CharField from '../../commons/fields/CharField.vue'

@Component({
  components: {
    RadioButtons,
    NavigationLinks,
    FileUploader,
    FormContainer,
    TextFieldEditor,
    DocumentField,
    CharField
  }
})
export default class WhatWeAchieved extends ToastMixin {
  @Prop() resultReport!: IPSResultReport
  @Prop({ default: false }) isInForeignCountry: boolean
  @Prop() formErrors!: { text?: string, activity_results?: string, goal_achieved?: string, page_heading?: string }

  @Watch('resultReport', { deep: true })
  onResultReportFormChanged(newVal: IPSResultReport) {
    this.$emit('form-updated', newVal)
  }

  get photoUploadUrl (): string {
    return this.resultReport ? API_URLS.PHOTOS.UPLOAD_PHOTO(this.resultReport.photo_album_slug) : ""
  }

  get fileUploadUrl (): string {
    return this.resultReport ? API_URLS.PHOTOS.UPLOAD_PHOTO(this.resultReport.file_album_slug) : null
  }

  onPhotosUploaded (files: IPhoto[]): void {
    this.resultReport.photos = files
  }

  onFilesUploaded (files: IPhoto[]): void {
    this.resultReport.files = files
  }

  onPhotosDeleted (deletedPhoto: IPhoto): void {
    this.resultReport.photos = this.resultReport.photos.filter(p => p.slug !== deletedPhoto.slug)
  }

  onFilesDeleted (deletedFiled: IPhoto): void {
    this.resultReport.files = this.resultReport.files.filter(file => file.slug !== deletedFiled.slug)
  }
}
